import React, { memo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import SatSelect from '@components/common/satUI/SatSelect';

/**
 * 송금인 선택
 */
export const SenderSelector = memo(
  ({ ownerPrspInfo, sender, disabled, handleSenderChange }) => {
    /**
     * 송금인 선택 옵션 조회
     */
    const getTransferPersonOptions = useCallback(customerRelationList => {
      return (customerRelationList ?? [])
        .map(relation => ({
          label: relation.name,
          value: relation.custNo,
        }))
        .concat({
          label: '직접입력',
          value: -1,
        });
    }, []);

    /**
     * 송금인 선택 핸들러
     */
    const handleTransferPersonChange = useCallback(
      customerRelationList => option => {
        const custNo = option.value;
        // 관계 목록에서 선택 시, custNo는 양수
        if (0 < custNo) {
          const getRelationByCustNo = (relationList, custNo) => {
            return relationList.find(relation => custNo === relation.custNo);
          };

          const selectedSender = getRelationByCustNo(
            customerRelationList,
            custNo,
          );
          handleSenderChange(selectedSender);
        } else {
          // 송금인 직접 직접입력 선택 시, custNo는 -1
          const getDummySender = () => ({
            adult: null, // boolean
            birthDay: '',
            custNo: -1, // number
            detachable: null,
            genderLabel: '',
            insuranceAge: null, // number
            legalAge: null, // number
            name: '',
            policyType: '',
            relationCode: '',
            relationDesc: '',
            relationLabel: '',
            representatve: false,
            rsdn: '',
          });
          handleSenderChange(getDummySender());
        }
      },
      [],
    );

    return (
      <SatSelect
        title="송금인 선택"
        value={sender.custNo}
        disabled={disabled}
        options={getTransferPersonOptions(ownerPrspInfo.customerRelationList)}
        onChange={handleTransferPersonChange(
          ownerPrspInfo.customerRelationList,
        )}
      />
    );
  },
);

SenderSelector.propTypes = {
  ownerPrspInfo: PropTypes.shape({
    customerRelationList: PropTypes.array,
  }),
  sender: PropTypes.shape({
    custNo: PropTypes.number,
  }),
  handleSenderChange: PropTypes.func.isRequired,
};
SenderSelector.defaultProps = {};

/**
 * 관계 선택
 */
export const RelationSelector = memo(
  ({ sender, showModal, disabled, handleSenderChange }) => {
    const [selectableRelationOptionList] = useState([
      { label: '배우자', value: '0' },
      { label: '부모', value: '1' },
      { label: '자녀', value: '2' },
      { label: '법인(개인사업자) 및 직원', value: '3' },
      { label: '기타', value: '100' },
    ]);

    /**
     * 관계 선택 핸들러
     */
    const handleRelationChange = useCallback(
      sender => option => {
        if (
          selectableRelationOptionList.find(a => '기타' === a.label).value ===
          option.value
        ) {
          showModal({
            visible: true,
            type: 'info',
            msg: '계약자와 송금인의 관계가 기타인 경우 반송으로 진행됩니다.',
          });
        }

        handleSenderChange(
          Object.assign({}, sender, {
            relationLabel: option.label,
            relationCode: option.value, // 관계 code 정의 없음.
          }),
        );
      },
      [],
    );

    return (
      <SatSelect
        title="관계선택"
        disabled={disabled}
        value={sender.relationCode}
        options={selectableRelationOptionList}
        onChange={handleRelationChange(sender)}
        initOption={{ label: '관계선택', value: '', useOption: false }}
      />
    );
  },
);

RelationSelector.propTypes = {
  sender: PropTypes.shape({
    relationLabel: PropTypes.string,
    relationCode: PropTypes.string,
  }),
  showModal: PropTypes.func.isRequired,
  handleSenderChange: PropTypes.func.isRequired,
};
RelationSelector.defaultProps = {};
